<template>
  <div class="login">
    <div class="title">忘记密码</div>
    <div class="cont">
      <van-form>
        <div class="form-box" style="margin-bottom: 20px">
          <van-field
            v-model="username"
            placeholder="请输入用户名"
            clearable
          ></van-field>
        </div>
      </van-form>
      <van-form v-show="passwordFormShow">
        <div class="form-box">
          <van-field
            v-model="mobile"
            placeholder="请输入手机号"
            clearable
          ></van-field>
          <van-field
            v-model="code"
            center
            clearable
            placeholder="请输入短信验证码"
          >
            <template #button>
              <span @click="!disabled&&getPhoneCode()" class="c-bule">{{btntxt}}</span>
            </template>
          </van-field>
          <van-field
            v-model="password"
            type="password"
            clearable
            placeholder="请输入密码"
          ></van-field>
          <van-field
            v-model="password1"
            type="password"
            clearable
            placeholder="请再次输入密码"
          ></van-field>
        </div>
      </van-form>
      <div class="form-btn">
        <van-button block type="info" @click="submitForm">
          确认修改
        </van-button>
        <div class="cont-tips">
          <span @click="toPage('/Login')">去登录</span> |
          <span @click="toPage('/Register')">注册账号</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Register",
  data() {
    return {
      passwordFormShow: false, //显示修改密码框
      username:'费旭伟货主',
      mobile:'',
      userId:'',
      code:'',
      password:'',
      password1:'',
      pattern: /\d{11}/,
      btntxt: "获取验证码",
      disabled: false,
      countTime: '' // 倒计时
    };
  },
  components: {
  },
  created() {
  },
  mounted() {
  },
  methods: {
    getPhoneCode(){
      let that = this
      let mobile = this.mobile
      console.log(that)
      console.log(mobile)
      if (mobile === '') {
        this.$toast('手机号不能为空')
        return false
      }else if (/\d{11}/.test(mobile) === false) {
        this.$toast('手机号格式不正确')
        return false
      }
      that._countDown(10)
      this.disabled = true;
      this.$api.apis.sendMobilecode({mobile:mobile}).then(res => {
        console.log(res);
        if(res.flag == '200'){
          this.$toast('验证码已发送')
        }else{
          this.$toast(res.msg)
          this.disabled = false;
        }
      })
    },
    //倒计时
    _countDown(time) {
      let interval = null
      this.countTime = this._handleTime(time)
      interval = setInterval(() => {
        time -= 1
        this.countTime = this._handleTime(time)
        if (time <= 0) {
          this.countTime = null
          this.btntxt = "重新获取验证码";
          this.disabled = false;
          window.clearInterval(interval)
        }else {
          this.disabled = true;
          this.btntxt = time + "s后重新获取";
        }
      }, 1000)
      this.$once('hook:beforeDestroy', () => {
        window.clearInterval(interval)
      })
    },
    //倒计时显示
    _handleTime(val) {
      val = val < 10 && val >= 0 ? '0' + val : val
      return val
    },
    sendMobilecode(values) {
    },
    submitForm() {
      if(this.passwordFormShow){

      }else{
        let username = this.username
        if(username){
          this.$api.apis.getUserByLoginname({username:username}).then(res => {
            console.log(res);
            if(res.flag == '200'){
              this.passwordFormShow = true
              this.userId = res.rsObj.id
              this.mobile = res.rsObj.mobile
            }else{
              this.$toast(res.msg)
            }
          })
        }else{
          this.$toast('请输入用户名')
        }
      }
    }
  },
  destroyed() {
  }
};
</script>
<style scoped lang="less">
  @import '../../styles/login.less';
</style>



// WEBPACK FOOTER //
// src/pages/Login/Forget.vue